import axios from "axios";
import Config from "../../config/index";

import {
  CREATE_OPERATIONS_FAILURE,
  CREATE_OPERATIONS_REQUEST,
  CREATE_OPERATIONS_SUCCESS,
  DELETE_OPERATIONS_FAILURE,
  DELETE_OPERATIONS_REQUEST,
  DELETE_OPERATIONS_SUCCESS,
  GET_OPERATIONS_FAILURE,
  GET_OPERATIONS_REQUEST,
  GET_OPERATIONS_SUCCESS,
  UPDATE_OPERATIONS_FAILURE,
  UPDATE_OPERATIONS_REQUEST,
  UPDATE_OPERATIONS_SUCCESS,
  GET_OPERATION_FOR_DROPDOWN_REQUEST,
  GET_OPERATION_FOR_DROPDOWN_SUCCESS,
  GET_OPERATION_FOR_DROPDOWN_FAILURE,
  GET_OPERATIONS_BY_PO_REQUEST,
  GET_OPERATIONS_BY_PO_SUCCESS,
  GET_OPERATIONS_BY_PO_FAILURE,
} from "./operationsTypes";

let baseUrl = Config.baseUrl;

const getOperationsRequest = () => {
  return {
    type: GET_OPERATIONS_REQUEST,
  };
};

const getOperationsSuccess = (payload) => {
  return {
    type: GET_OPERATIONS_SUCCESS,
    payload: payload,
  };
};

const getOperationsFailure = (error) => {
  return {
    type: GET_OPERATIONS_FAILURE,
    payload: error,
  };
};

const getOperations = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getOperationsRequest());

    // let url = `${baseUrl}/operation`;

    // /?page_number&rows_per_page&search&download
    let url = `${baseUrl}/operation?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getOperationsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getOperationsFailure(err.response));
      });
  };
};

// const getLabelsWithPaginationRequest = () => {
//   return {
//     type: GET_LABELS_WITH_PAGINATION_REQUEST,
//   };
// };

// const getLabelsWithPaginationSuccess = (payload) => {
//   return {
//     type: GET_LABELS_WITH_PAGINATION_SUCCESS,
//     payload: payload,
//   };
// };

// const getLabelsWithPaginationFailure = (error) => {
//   return {
//     type: GET_LABELS_WITH_PAGINATION_FAILURE,
//     payload: error,
//   };
// };

// const getLabelsWithPagination = (pageNo, rowsPerPage, search, jwtToken) => {
//   let headers = {
//     headers: {
//       Authorization: `Bearer ${jwtToken}`,
//     },
//   };

//   return (dispatch) => {
//     dispatch(getLabelsWithPaginationRequest());

//     let url = `${baseUrl}/label_size?page_number=${
//       pageNo + 1
//     }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;

//     axios
//       .get(url, headers)
//       .then((response) => {
//         dispatch(getLabelsWithPaginationSuccess(response.data));
//       })
//       .catch((err) => {
//         dispatch(getLabelsWithPaginationFailure(err.response));
//       });
//   };
// };

const createOperationsRequest = () => {
  return {
    type: CREATE_OPERATIONS_REQUEST,
  };
};

const createOperationsSuccess = (payload) => {
  return {
    type: CREATE_OPERATIONS_SUCCESS,
    payload: payload,
  };
};

const createOperationsFaliure = (error) => {
  return {
    type: CREATE_OPERATIONS_FAILURE,
    payload: error,
  };
};

const createOperations = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(createOperationsRequest());
    let url = `${baseUrl}/operation`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createOperationsSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createOperationsFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const updateOperationsRequest = () => {
  return {
    type: UPDATE_OPERATIONS_REQUEST,
  };
};

const updateOperationsSuccess = (payload) => {
  return {
    type: UPDATE_OPERATIONS_SUCCESS,
    payload: payload,
  };
};

const updateOperationsFaliure = (error) => {
  return {
    type: UPDATE_OPERATIONS_FAILURE,
    payload: error,
  };
};

const updateOperations = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(updateOperationsRequest());
    let url = `${baseUrl}/operation`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(updateOperationsSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(updateOperationsFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const deleteOperationsRequest = () => {
  return {
    type: DELETE_OPERATIONS_REQUEST,
  };
};

const deleteOperationsSuccess = (payload) => {
  return {
    type: DELETE_OPERATIONS_SUCCESS,
    payload: payload,
  };
};

const deleteOperationsFaliure = (error) => {
  return {
    type: DELETE_OPERATIONS_FAILURE,
    payload: error,
  };
};

const deleteOperations = (id, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(deleteOperationsRequest());
    let url = `${baseUrl}/operation?operationId=${id}`;

    return axios
      .delete(url, headers)
      .then((response) => {
        dispatch(deleteOperationsSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deleteOperationsFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

// const getPrintersForLabelCreationRequest = () => {
//   return {
//     type: GET_PRINTERS_FOR_LABEL_REQUEST,
//   };
// };

// const getPrintersForLabelCreationSuccess = (payload) => {
//   return {
//     type: GET_PRINTERS_FOR_LABEL_SUCCESS,
//     payload: payload,
//   };
// };

// const getPrintersForLabelCreationFailure = (error) => {
//   return {
//     type: GET_PRINTERS_FOR_LABEL_FAILURE,
//     payload: error,
//   };
// };

// const getPrintersForLabelCreation = (jwtToken) => {
//   let headers = {
//     headers: {
//       Authorization: `Bearer ${jwtToken}`,
//     },
//   };

//   return (dispatch) => {
//     dispatch(getPrintersForLabelCreationRequest());

//     let url = `${baseUrl}/asset/get_printer`;

//     axios
//       .get(url, headers)
//       .then((response) => {
//         dispatch(getPrintersForLabelCreationSuccess(response.data));
//       })
//       .catch((err) => {
//         dispatch(getPrintersForLabelCreationFailure(err.response));
//       });
//   };
// };

const getOperationsForDropDownRequest = () => {
  return {
    type: GET_OPERATION_FOR_DROPDOWN_REQUEST,
  };
};

const getOperationsForDropDownSuccess = (payload) => {
  return {
    type: GET_OPERATION_FOR_DROPDOWN_SUCCESS,
    payload: payload,
  };
};

const getOperationsForDropDownFailure = (error) => {
  return {
    type: GET_OPERATION_FOR_DROPDOWN_FAILURE,
    payload: error,
  };
};

const getOperationsForDropDown = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getOperationsForDropDownRequest());
    let url = `${baseUrl}/operation_without_page`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getOperationsForDropDownSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getOperationsForDropDownFailure(err.response));
      });
  };
};

const getOperationsByPoRequest = () => {
  return {
    type: GET_OPERATIONS_BY_PO_REQUEST,
  };
};

const getOperationsByPoSuccess = (payload) => {
  return {
    type: GET_OPERATIONS_BY_PO_SUCCESS,
    payload: payload,
  };
};

const getOperationsByPoFailure = (error) => {
  return {
    type: GET_OPERATIONS_BY_PO_FAILURE,
    payload: error,
  };
};

const getOperationsByPo = (poId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getOperationsByPoRequest());
    let url = `${baseUrl}/operation/get_by_poId?poId=${poId}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getOperationsByPoSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getOperationsByPoFailure(err.message));
      });
  };
};

export {
  getOperations,
  createOperations,
  updateOperations,
  deleteOperations,
  getOperationsForDropDown,
  getOperationsByPo,
};
